// The free-trial pages' scorer, from the prototypes' script: seven areas scored 1 to 5, a stage from the total,
// up to three areas under the target as the focus, and the lowest area as the bottleneck.

export const TARGET = 4
export const MAX_SCORE = 5
export const FOCUS_LIMIT = 3

/** The stage whose minimum total the scores reach, the last one that does */
export const stageFor = (stages, sum) => stages.reduce((found, stage) => (sum >= stage.min ? stage : found), stages[0])

/** What the sliders add up to */
export const assessTrial = ({ areas, stages, bottlenecks }, scores) => {
  const sum = scores.reduce((total, score) => total + score, 0)
  const total = areas.length * MAX_SCORE
  const pct = Math.round((sum / total) * 100)
  const stage = stageFor(stages, sum)
  const rung = stages.indexOf(stage) + 1
  // lowest first, the earlier area first on a tie
  const ordered = scores
    .map((score, index) => ({ score, index }))
    .sort((a, b) => a.score - b.score || a.index - b.index)
  const focus = ordered.filter((entry) => entry.score < TARGET).slice(0, FOCUS_LIMIT)
  const lowest = ordered[0]
  return {
    sum,
    total,
    pct,
    stage,
    rung,
    focus: focus.map((entry) => areas[entry.index]),
    lowest: { name: areas[lowest.index], score: lowest.score, ...bottlenecks[lowest.index] },
  }
}
